module.exports = __webpack_public_path__ + "img/exchage-btn.ec30900b.png";